import { faInfoCircle } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, SxProps, Typography } from "@mui/material";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { sxGreenTextButton } from "../../../assets/styles/CommonSxProps";
import DefaultButton from "../../../components/Accessibility/DefaultButton";
import { ScheduleDetailProps } from "../../../interfaces/props/SaudeOnline/ScheduleDetailProps";
import { sxBoxScheduleDetail, sxScheduleDetailKey, sxScheduleDetailStatusGreen, sxScheduleDetailStatusRed, sxScheduleDetailStatusYellow, sxScheduleDetailValueStandard, } from "./sxProps";

const ScheduleDetailFrame: React.FC<ScheduleDetailProps> = ({
  scheduleDetailKey, scheduleDetailValue, scheduleDetailAditionalValue, instrucoesDeAtendimento, openModalInstrucoes
}) => {

  const { textStyleAccessibility } = useAccessibility();

  const returnKeyFormattedText = (key: string): string => {
    switch (key) {
      case "medico": return "Profissional:";
      case "especialidade": return "Especialidade:";
      case "endereco": return "Endereço:";
      case "telefone": return "Telefone:";
      case "dataHoraAgendamento": return "Data e hora da consulta:";
      case "tipoAtend": return "Tipo da consulta:";
      case "dataConfirmacao": return "Data da confirmação:";
      case "status": return "Status:";
      default: return "";
    }
  };

  const getStatusDetailSx = (): SxProps => {
    switch (scheduleDetailValue) {
      case 'confirmado': case 'concluido':
        return sxScheduleDetailStatusGreen;
      case 'agendado':
        return sxScheduleDetailStatusYellow;
      case 'cancelado': case 'faltou':
        return sxScheduleDetailStatusRed;
      default:
        return sxScheduleDetailValueStandard;
    }
  }

  return (
    <Box sx={sxBoxScheduleDetail}>
      <Typography style={textStyleAccessibility} sx={sxScheduleDetailKey}>{returnKeyFormattedText(scheduleDetailKey)}</Typography>
      <Typography style={textStyleAccessibility} sx={scheduleDetailKey === 'status' ? getStatusDetailSx() : sxScheduleDetailValueStandard}>{scheduleDetailValue === 'faltou' ? 'Ausente' : scheduleDetailValue}</Typography>
      {scheduleDetailAditionalValue && <Typography sx={sxScheduleDetailValueStandard}>{scheduleDetailAditionalValue}</Typography>}
      {instrucoesDeAtendimento &&
        <DefaultButton variant="text" sx={sxGreenTextButton} onClick={openModalInstrucoes}>
          <FontAwesomeIcon icon={faInfoCircle} />&nbsp; <u>Instruções de atendimento</u>
        </DefaultButton>
      }
    </Box>
  )
}

export default ScheduleDetailFrame;